import { TablItem } from 'components/atoms/TabBar';

export type MenuItem = {
    value: string, 
    display: string,
    subMenu?: Array<MenuItem>,
};

export type GroupMenu = {
    display: string,
    icon: string, 
    menuList?: Array<MenuItem>,
};

const site: string | null = sessionStorage.getItem('loginUser.site');
const isAdministrator: string | null = sessionStorage.getItem('loginUser.administrator');

const isHavingApprovalPrivilege = sessionStorage.getItem('loginUser.isHavingApprovalPrivilege');

// =============//
// ----HQ------//
// ============//
// General master setting
const generalMasterTabbar: Array<MenuItem> = [
    { value: 'organizations', display: '組織' },
    { value: 'staffs', display: 'スタッフ' },
    { value: 'executive', display: '役職' },
    { value: 'holiday', display: '祝日' },
    // { value: 'areas', display: 'エリア' },
    // { value: 'business', display: '業態' },
];

// Attendance master setting
const attendanceMasterTabbar: Array<MenuItem> = [
    { value: 'vacationMaster', display: '休暇' },
    { value: 'masterPaidHolidayPattern', display: '有給付与パターン' },
    // { value: '', display: '業務' },
    { value: 'masterTerm', display: '時間帯' },
    { value: 'masterWorkingDays', display: '所定労働日数' },
    { value: 'masterWorkingHours', display: '所定労働時間' },
    { value: 'masterEmploymentForm', display: '雇用形態' },
    { value: 'masterShiftPattern', display: 'シフトパターン' },
    { value: 'masterSettingAgreement36', display: '36協定アラート設定' },
    { value: 'masterAttendSetting', display: '勤怠設定' },
];

// Face master setting
const faceRegistrationMasterTabbar: Array<TablItem> = [
    { value: 'masterShopFaceRegistration', display: '顔写真登録' }
];

// Shop Specify setting
const masterShopSpecifyMasterTabbar: Array<TablItem> = [
    { value: 'masterShopSpecify', display: '端末設定' }
];

// Time confirmation output layout
const timeConfirmationOutputLayoutTabbar: Array<TablItem> = [
    { value: 'masterTimeOutputLayout', display: '勤怠確定出力レイアウト' }
];

// Help
const helpTabbar: Array<MenuItem> = [
    { value: 'help', display: 'ヘルプ' }
];

export const helpPages: string[] = [
    "https://help.hinata.cydas.com/nb-tags/for-personal/",
    "https://help.hinata.cydas.com/nb-tags/for-stores/",
    "https://help.hinata.cydas.com/nb-tags/for-headquarters/",
];

// Attendance management
const attendanceManagementTabbar: Array<MenuItem> = [
    { value: 'attendApplicationApproval', display: '承認' },
    { value: 'attendStampList', display: '打刻データ確認' },
    { value: 'attendApplicationList', display: '勤怠申請' },
    { value: 'attendError', display: 'エラー' },
    { value: 'attendHolidayManagement', display: '休暇' },
    { value: 'attendHeadquartersFinal', display: '確定' },
    { value: 'timeRecalculation', display: '再計算' },
    { value: 'attendAchievementOutput', display: '印刷' },
    { value: 'attendCSVOutput', display: 'CSV出力' }
];

// Face Recognize
const faceRecognizeTabbar: Array<MenuItem> = [
    { value: 'id', display: 'ID' },
    { value: 'face', display: '顔認証'},
    { value: 'gps', display: 'GPS'}
];

// Stammping
const stampingRecordTabbar: Array<MenuItem> = [
    { value: 'stampHistory', display: '打刻実績' },
    { value: 'GpsStampHistory', display: 'GPS打刻実績' }
];

// Shift
const shiftTabbar: Array<MenuItem> = [
    { value: 'dailyShift', display: '日次' },
    { value: 'monthlyShift', display: '月次' }
];

// =============//
// --SHOP---//
// ============//
const attendanceManagementShopTabbar: Array<MenuItem> = [
    { value: 'attendApplicationApproval', display: '承認' },
    { value: 'attendStampList', display: '打刻データ確認' },
    { value: 'attendApplicationList', display: '勤怠申請' },
    { value: 'attendError', display: 'エラー' },
    { value: 'attendHolidayManagement', display: '休暇' },
    { value: 'dailyShift', display: '日次' },
    { value: 'monthlyShift', display: '月次' },
    { value: 'attendCSVOutput', display: 'CSV出力' }
];

const settingManagementShopTabbar: Array<MenuItem> = [
    { value: 'masterOrganizeSetting', display: '組織設定' },
    { value: 'masterShiftPattern', display: 'シフトパターン' },
    { value: 'masterShopSpecify', display: '端末設定' },
    { value: 'masterShopFaceRegistration', display: '顔写真登録' },
    { value: 'masterICCard', display: 'ICカード登録' }
];

const personalAttendanceManagementTabbar: Array<MenuItem> = [
    { value: 'attendStampList', display: '打刻実績' },
    { value: 'hopeShift', display: '希望シフト' },
    { value: 'shiftView', display: 'シフト閲覧' },
    { value: 'attendApplicationList', display: '勤怠申請' }
];

if (site === String(1) && isHavingApprovalPrivilege === "true") {
    personalAttendanceManagementTabbar.push({ value: 'attendApplicationApproval', display: '承認' });
}

const personalAttendanceSettingTabbar: Array<MenuItem> = [
    { value: 'personalSetting', display: '通知設定' }
];

const overtimeAlertTabbar: Array<MenuItem> = [
    { value: 'monthlyAgreement36', display: '月次' },
    { value: 'yearlyAgreement36', display: '年次' }
];

const agreement36Tabbar: Array<MenuItem> = [
    { value: 'agreement36', display: 'ホーム' },
    { 
        value: '', 
        display: '残業アラート',
        subMenu: overtimeAlertTabbar
    }
];

const settingsTabbar: Array<MenuItem> = [
    { 
        value: '', 
        display: '一般マスタ',
        subMenu: generalMasterTabbar
    },
    { 
        value: '', 
        display: '勤怠マスタ',
        subMenu: attendanceMasterTabbar
    },
    { 
        value: 'masterTimeOutputLayout', 
        display: '勤怠確定出力レイアウト' 
    },
    { 
        value: 'masterShopFaceRegistration', 
        display: '顔写真登録' 
    },
    { 
        value: 'masterICCard', 
        display: 'ICカード登録' 
    },
    { 
        value: 'masterShopSpecify', 
        display: '端末設定' 
    }
];

export const menuListHQ = [
    {
        mainMenu: 'ホーム',
        icon: 'house',
        subMenu: agreement36Tabbar
    },
    {
        mainMenu: '勤怠管理',
        icon: 'house',
        subMenu: attendanceManagementTabbar
    },
    {
        mainMenu: '勤怠',
        icon: 'manageRecorder',
        subMenu: stampingRecordTabbar
    },
    {
        mainMenu: 'シフト',
        icon: 'manageRecorder',
        subMenu: shiftTabbar
    },
    {
        mainMenu: '設定管理',
        icon: 'settings',
        subMenu: settingsTabbar
    },
    {
        mainMenu: '勤怠管理',
        icon: 'helpMenu',
        subMenu: helpTabbar
    }
];

export const menuSuperAdministrator: Array<GroupMenu> = [
    {
        display: 'ホーム',
        icon: 'house',
        menuList: agreement36Tabbar
    },
    {
        display: '勤務管理',
        icon: 'recorder',
        menuList: attendanceManagementTabbar
    },
    {
        display: '打刻実績',
        icon: 'historyStamp',
        menuList: stampingRecordTabbar
    },
    {
        display: 'シフト',
        icon: 'shift',
        menuList: shiftTabbar
    },
    {
        display: '設定管理',
        icon: 'settingsMenu',
        menuList: settingsTabbar
    },
    {
        display: '打刻',
        icon: 'timeRecorder',
        menuList: faceRecognizeTabbar
    },
    {
        display:'ヘルプ',
        icon: 'helpMenuLeft',
        menuList: helpTabbar
    }
];

export const menuHrRole: Array<GroupMenu> = [
    {
        display: 'ホーム',
        icon: 'house',
        menuList: agreement36Tabbar
    },
    {
        display: '勤務管理',
        icon: 'recorder',
        menuList: attendanceManagementTabbar
    },
    {
        display: '打刻実績',
        icon: 'historyStamp',
        menuList: stampingRecordTabbar
    },
    {
        display: 'シフト',
        icon: 'shift',
        menuList: shiftTabbar
    },
    {
        display: '打刻',
        icon: 'timeRecorder',
        menuList: faceRecognizeTabbar
    },
    {
        display:'ヘルプ',
        icon: 'helpMenuLeft',
        menuList: helpTabbar
    }
];

export const menuLeadRole: Array<GroupMenu> = [
    {
        display: 'ホーム',
        icon: 'house',
        menuList: agreement36Tabbar
    },
    {
        display: '勤務管理',
        icon: 'recorder',
        menuList: attendanceManagementShopTabbar
    },
    {
        display: '打刻実績',
        icon: 'historyStamp',
        menuList: stampingRecordTabbar
    },
    {
        display: 'シフト',
        icon: 'shift',
        menuList: shiftTabbar
    },
    {
        display: '設定管理',
        icon: 'settingsMenu',
        menuList: settingManagementShopTabbar
    },
    {
        display: '打刻',
        icon: 'timeRecorder',
        menuList: faceRecognizeTabbar
    },
    {
        display:'ヘルプ',
        icon: 'helpMenuLeft',
        menuList: helpTabbar
    }
];

export const menuSubLeadRole: Array<GroupMenu> = [
    {
        display: 'ホーム',
        icon: 'house',
        menuList: agreement36Tabbar
    },
    {
        display: '勤務管理',
        icon: 'recorder',
        menuList: attendanceManagementShopTabbar
    },
    {
        display: '打刻実績',
        icon: 'historyStamp',
        menuList: stampingRecordTabbar
    },
    {
        display: 'シフト',
        icon: 'shift',
        menuList: shiftTabbar
    },
    {
        display: '打刻',
        icon: 'timeRecorder',
        menuList: faceRecognizeTabbar
    },
    {
        display:'ヘルプ',
        icon: 'helpMenuLeft',
        menuList: helpTabbar
    }
];

export const menuPersonalRole: Array<GroupMenu> = [
    {
        display: 'ホーム',
        icon: 'house',
        menuList: agreement36Tabbar
    },
    {
        display: '勤務管理',
        icon: 'recorder',
        menuList: personalAttendanceManagementTabbar
    },
    {
        display: '設定管理',
        icon: 'settingsMenu',
        menuList: personalAttendanceSettingTabbar
    },
    {
        display: '打刻',
        icon: 'timeRecorder',
        menuList: faceRecognizeTabbar
    },
    {
        display:'ヘルプ',
        icon: 'helpMenuLeft',
        menuList: helpTabbar
    }
];

export const getMenuListByRole = (site: string, isAdministrator: string, newMenuSuperAdministrator: any) => {
    if(site === '3' && isAdministrator === "true") {
        return newMenuSuperAdministrator;
    }
    if(site === '3' && isAdministrator === "false") {
        return menuHrRole;
    }
    if(site === '2' && isAdministrator === "true") {
        return menuLeadRole;
    }
    if(site === '2' && isAdministrator === "false") {
        return menuSubLeadRole;
    }
    return menuPersonalRole
};

export const getHelpPage = (site: number) => {
    window.open(helpPages[Number(site) - 1], "_blank");
};

// export const hqTopbar1 = [generalMasterTabbar, attendanceMasterTabbar, faceRegistrationMasterTabbar, timeConfirmationOutputLayoutTabbar, masterShopSpecifyMasterTabbar, helpTabbar, attendanceManagementTabbar];
// export const hqTopbar2 = [agreement36Tabbar, attendanceManagementTabbar, stampingRecordTabbar, shiftTabbar, generalMasterTabbar];
// export const hqTopbarGeneral = [agreement36Tabbar, attendanceManagementTabbar, stampingRecordTabbar, shiftTabbar, helpTabbar];

// export const shopTopbar = [agreement36Tabbar, attendanceManagementShopTabbar, stampingRecordTabbar ,settingManagementShopTabbar, helpTabbar];
// export const shopTopbarGeneral = [agreement36Tabbar, attendanceManagementShopTabbar, stampingRecordTabbar ,helpTabbar];
// export const personalTopbar = [agreement36Tabbar, personalAttendanceManagementTabbar, personalAttendanceSettingTabbar, helpTabbar];
